import PT from 'prop-types';

// mui imports
import { CardContent } from '@mui/material';

import MenuItem from './MenuItem';

const sideCardBody = props => {
  const { toggle, items } = props;
  return toggle ? (
    <CardContent>
      {items.map((item, i) => (
        <MenuItem key={i} {...item} />
      ))}
    </CardContent>
  ) : null;
};

sideCardBody.propTypes = {
  toggle: PT.bool.isRequired,
  items: PT.arrayOf(PT.object).isRequired
};

export default sideCardBody;
